import React from "react";
import { MyChat } from "./MyChat";
import './index.css'; // <--- THIS IS CRUCIAL FOR CSS IMPORT


function App() {
  return (
    <div className="AppContainer">
      <img src="/logo.svg" alt="HRMThread Assistant Logo" className="AppLogo" />
	   <p className="AppDescription">
        	Welcome! I am your Support Agent for HRMThread and ready to help with your questions.
        </p>
      <MyChat />
    </div>
  );
}

export default App;
